import React from 'react';
import MenuItem from '../MenuItem';

export default function renderEnabledMenuItems(items, props, clickWrapper = null) {
    const enabledMenuItems = items.filter(item => item(props).isEnabled);

    return enabledMenuItems.map((info) => {
        const result = info(props);

        const { id, action } = result;
        let { onClick } = result;

        if (clickWrapper) {
            const oldOnClick = onClick;

            onClick = () => {
                clickWrapper(oldOnClick);
            };
        }

        const menuItemProps = {
            id,
            onClick,
            action,
            key: id,
        };

        return <MenuItem {...menuItemProps} />;
    });
}
